class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme.Cart = this;
    this.drawer = this.closest("drawer-component");
    window.FoxTheme.CartDrawer = this.drawer;
    this.openWhenAdded = this.dataset.openWhenAdded === "true";
  }

  connectedCallback() {
    window.FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (state) => {
        this.renderContents(state);
        Shopify.trademarkClass(['®', '™'])
      }
    );
  }

  renderContents(parsedState, renderFooter = true) {
    this.classList.contains("is-empty") && this.classList.remove("is-empty");
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer();
        document.body.classList.add("prevent-scroll");
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
    ];

    if (renderFooter) {
      sections.push({
        id: "cart-drawer",
        selector: ".f-drawer__footer",
      });
    }

    return sections;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(
      document.querySelector("cart-drawer"),
      { overlay: document.querySelector("cart-drawer") }
    );
  }
  getSectionsToRender() {
    return [
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__block-subtotal",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Express checkout in cart drawer: render only the allowed wallets.
// Shopify lays the buttons out (shadow DOM grid) from the `wallet-configs` attribute,
// so wallets are filtered there before the element is upgraded; hiding with CSS leaves empty cells.
if (!customElements.get("express-checkout-filter")) {
  customElements.define(
    "express-checkout-filter",
    class ExpressCheckoutFilter extends HTMLElement {
      connectedCallback() {
        const template = this.querySelector("template");
        if (!template) return;

        const allowed = (this.dataset.wallets || "").split(",").map((name) => name.trim());
        const content = template.content.cloneNode(true);

        content.querySelectorAll("[wallet-configs]").forEach((el) => {
          try {
            const configs = JSON.parse(el.getAttribute("wallet-configs"));
            el.setAttribute(
              "wallet-configs",
              JSON.stringify(configs.filter((config) => allowed.includes(config.name)))
            );
          } catch (error) {
            console.warn("[Express checkout] wallet-configs not filtered", error);
          }
        });

        // Scripts inside a <template> don't run once inserted; recreate them
        content.querySelectorAll("script").forEach((oldScript) => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });

        template.remove();
        this.appendChild(content);
      }
    }
  );
}
